module.exports = __webpack_public_path__ + "static/media/bay2022FeaturesBanner_Mobile_411x93px_@2x.3e88dff0.jpg";